import { useQuery, useMutation, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { getInbox, markInboxRead, InboxListResponse } from '../api/inboxApi';
import { invalidateNotificationCounts } from './useNotificationCounts';

export const INBOX_KEY = ['inbox'] as const;

export function inboxQueryOptions(limit = 20, offset = 0) {
  return {
    queryKey: ['inbox', 'list', limit, offset] as const,
    queryFn: () => getInbox(limit, offset),
    staleTime: 30 * 1000,
  };
}

export function useInbox(limit = 20, offset = 0): UseQueryResult<InboxListResponse, Error> {
  return useQuery(inboxQueryOptions(limit, offset));
}

export function useMarkInboxRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markInboxRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: INBOX_KEY });
      invalidateNotificationCounts(qc);
    },
  });
}
